const React = require('react');
const map = require('mn-utils/map');
const formatTime = require('mn-utils/formatTime');
const {
  getRFC3339,
} = formatTime;
const getCountryByCode = require('../../../../utils/getCountryByCode');
const Tooltip = require('../../../dumb/Tooltip/A');
const ColA = require('../../../dumb/Col/A');
const ColB = require('../../../dumb/Col/B');

const Document = require('./Document');


module.exports = (props) => {
  return (
    <div className="ov ovxA">
      <div className="wmin1400">
        <div>
          <div
            className="layoutRow fhaS fvaC h70 ph10 pv5 cA4A7AC f12
              fw5 bc505255 bs b bb2"
          >
            <ColB className="w(|min)140">ID</ColB>
            <ColB className="w(|min)140">Full name</ColB>
            <ColB className="w(|min)100">% of shares</ColB>
            <ColB className="w(|min)140">Date of birth</ColB>
            <ColB className="w(|min)140">Country of <br/>residence</ColB>
            <ColB className="w(|min)140">Country of <br/>birth</ColB>
            <ColB className="w(|min)140">Passport / <br/>national ID number</ColB>
            <ColB className="w(|min)140">Passport or <br/>national ID</ColB>
            <ColB className="w(|min)140">Proof of address</ColB>
            <ColB className="w(|min)140">Updated at</ColB>
          </div>
        </div>
        <div>
          {map(props.items, (item) => {
            const {
              id,
              document_identity: documentIdentity,
              document_address: documentAddress,
            } = item;
            const createdAt = item.created_at || '';
            const _createdAt = formatTime(createdAt);


            return (
              <div
                key={id}
                className={`layoutRow fhaS fvaC h70 ph10 pv5 dn bgF.03:h w
                  bc4B4D51 bs b bb1 ` + (props.className || '')}
              >
                <ColA className="w(|min)140">
                  <Tooltip>{id}</Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip>{item.full_name}</Tooltip>
                </ColA>
                <ColA className="w(|min)100">
                  <Tooltip>{item.owner_percent}%</Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip>
                    {formatTime(item.date_of_birth, '{dd}.{mm}.{yyyy}')}
                  </Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip>{getCountryByCode(item.country_of_residence)}</Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip>{getCountryByCode(item.country_of_birth)}</Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip>{item.passport_or_nation_id}</Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip title={documentIdentity && documentIdentity.file_name || '-'}>
                    <Document data={documentIdentity}/>
                  </Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip title={documentAddress && documentAddress.file_name || '-'}>
                    <Document data={documentAddress}/>
                  </Tooltip>
                </ColA>
                <ColA className="w(|min)140">
                  <Tooltip
                    title={getRFC3339(createdAt)}
                    value={_createdAt}
                  >{_createdAt}</Tooltip>
                </ColA>
              </div>
            );
          }, [])}
        </div>
      </div>
    </div>
  );
};
